export default "__VITE_ASSET__CgUL10_1__"